
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import * as CelebritiesAPI from '@api/Celebrities';
import { getUserData } from '@common/utils';
import Routes from '@constants/routes';
import Profile from '@layouts/Profile/Profile';
import { ProfileProps } from '@layouts/Profile/Profile.types';
import { GetServerSidePropsContext } from 'next';

 const _getServerSideProps = async function (context: GetServerSidePropsContext): Promise<any> {
  const getCelebrityInfo = async (): Promise<CelebritiesAPI.CelebrityResponse | null> => {
    if (!context.query.slug || context.query.slug[0] == '') return null;
    const response = await CelebritiesAPI.GetCelebrityInfo({ slug: context.query.slug[0] }, context.locale);
    if (!response.success) return null;
    return response.data as CelebritiesAPI.CelebrityResponse;
  };
  const celebrityInfo = await getCelebrityInfo();

  if (!celebrityInfo) {
    return {
      redirect: {
        destination: Routes.ERROR_404,
        permanent: false,
      },
    };
  }

  if (!celebrityInfo.available) {
    return {
      redirect: {
        destination: Routes.HOME,
        permanent: false,
      },
    };
  }

  const user = getUserData(context.req.headers.cookie);
  return {
    props: {
      user,
      ssrCelebInfo: celebrityInfo,
      ssrLocale: context.locale,
    },
  };
};

export default function ProfilePage(props: ProfileProps): JSX.Element {
  return <Profile ssrCelebInfo={props.ssrCelebInfo} user={props.user} ssrLocale={props.ssrLocale} />;
}


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/celebrity/[...slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  